<template>
  <label class="block text-sm font-medium text-gray-700 dark:text-slate-300">
    <span>{{ label }}</span>
    <input
      :value="modelValue"
      :type="type"
      :required="required"
      class="mt-1 w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 outline-none transition-all focus:border-primary/50 focus:ring-2 focus:ring-primary/20 dark:border-white/5 dark:bg-dark-surface dark:text-slate-200"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </label>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    modelValue: { type: [String, Number], default: "" },
    label: { type: String, required: true },
    type: { type: String, default: "text" },
    required: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
};
</script>
